const registerModule = {
  title1: "Please enter cellphone number",
  title2: "We will send verification code by text message",
  register: "Register",
  nextStep: "Next step",
  areaCodeTitle: "Cellphone area code selection",
  resendText: "Verification code can be sent again after *",
  codePrompt: "Please enter four figures text message verification code",
  setPassword: "Set password",
  sendCodeText:
    "We will send text message verification code to above number. Affected by the communication situation, text message may be slightly delayed in receiving.",
  isPhone: "Please enter cellphone number",
  sendCodeAgain: "Please send the text message to * again.",
  sendSuccess: "Send Success",
  passwordHint: "Please enter 6-32 English ordigital half-width characters",
  isPassword: "Password can't be empty",
  samePassword: "Two passwords are different",
  registerSuccess: "Registered successfully",
  forgetPwTitle: "Forget the password",
  newPassword: "New password",
  restSuccess: "Modify successfully",
  sendCode: "Get verification code",
  requiredEmail: 'Please fill in the email',
  phoneError: "Incorrect phone number format",
};

export default registerModule;
